module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_180_LEFT.1e320d6e.png";